import {
  AGENT_APPLICATION_SOURCES,
  STAND_IN_APPLICATION_SOURCES,
  WORKLOAD_STATUS
} from "./application.const"

import type {
  AgentApplicationSource,
  Application,
  StandInApplicationSource
} from "./application.types"

export const isTerminatedApplication = (workloadStatus?: string) =>
  workloadStatus === WORKLOAD_STATUS.TERMINATED

export const getDescription = (application: Application) => {
  const { environment, namespace } = application || {}

  return `${environment || "-"}/${namespace || "-"}`
}

export const isStandInApplicationSource = (
  source?: string | null
): source is StandInApplicationSource =>
  STAND_IN_APPLICATION_SOURCES.some((value) => value === source)

export const isAgentApplicationSource = (
  source?: string | null
): source is AgentApplicationSource =>
  AGENT_APPLICATION_SOURCES.some((value) => value === source)
